import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { map } from "rxjs/operators";
import {
  CardValidationService,
  CardValidationDetails,
  CardValidationResponse,
} from "./../../services/card-validation.service";
import { SpinnerService } from "../spinner/spinner.service";
import { UserService } from "../../services/user.service";

@Component({
  selector: "gca-card-activation",
  templateUrl: "./card-activation.component.html",
  styleUrls: ["./card-activation.component.scss"],
})
export class CardActivationComponent implements OnInit, OnDestroy {
  loginChangedSub: Subscription;

  errorMessage = null;
  form: FormGroup;
  sub: Subscription;
  submitted = false;
  cardNumber: string = null;
  pinNumber: string = null;

  constructor(
    private route: ActivatedRoute,
    private cardValidationService: CardValidationService,
    //    private googleAnalyticsService: GoogleAnalyticsService,
    private fb: FormBuilder,
    private router: Router,
    private spinnerService: SpinnerService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.cardValidationService.removeCardValidationDetails();


    this.sub = this.route.queryParams
      .pipe(
        map((params) => {
          let shopButtonUrl = "";
          if (params && params.shopButtonUrl) {
            shopButtonUrl = decodeURIComponent(params.shopButtonUrl);
            localStorage.setItem("shopButtonUrl", shopButtonUrl);
          }

          if (params.sourceId) {
            localStorage.setItem("sourceId", params.sourceId);
          }

          if (params.cardNumber && params.pinNumber) {
            this.cardNumber = params.cardNumber;
            this.pinNumber = params.pinNumber;
            localStorage.setItem("cardDetailsWasPassedInUrl", "true");
            localStorage.setItem('cardDetailsUrl', location.search);
          }
        })
      )
      .subscribe();

    this.buildForm();

    this.loginChangedSub = this.userService.loginChanged$.subscribe((res) => {
      if (localStorage.getItem("cardDetailsWasPassedInUrl")) {
        this.onSubmit();
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.loginChangedSub.unsubscribe();
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.form.valid) {
      this.spinnerService.showSpinner({ text: "Validating gift card…" });
      this.cardValidationService.validateCard(this.form.value).subscribe(
        (response: CardValidationResponse) => {
          this.spinnerService.hideSpinner();

          if (response.Result === 0) {
            this.errorMessage = response.ResultMessage;
          } else {
            //this.googleAnalyticsService.gtagReportEvent('Validate', 'GC Activation', 'Activate');
            this.cardValidationService.cardValidationDetails =
              new CardValidationDetails(
                this.form.value.AccountNumber,
                this.form.value.SecurityID,
                response.EnrollerID,
                response.CardCurrencyPrefix,
                response.CardValue
              );

            //if user already login, do card activation. or send to registration page.
            if (this.userService.isLoggedIn) {
              this.activateGiftCard();
            } else {
              this.router.navigate(["/registration"]);
            }
          }
        },
        (error) => {
          this.spinnerService.hideSpinner();
          this.errorMessage = error.Message
            ? error.Message
            : "Something went wrong...";
        }
      );
    }
  }

  showError(controlName: string): boolean {
    return (
      ((<FormGroup>this.form.controls[controlName]).invalid &&
        (<FormGroup>this.form.controls[controlName]).dirty) ||
      ((<FormGroup>this.form.controls[controlName]).invalid && this.submitted)
    );
  }

  private buildForm(): void {
    this.form = this.fb.group({
      AccountNumber: [
        this.cardNumber,
        [
          Validators.required,
          Validators.maxLength(8),
          Validators.minLength(8),
          Validators.pattern(/^$|^[A-Za-z0-9]+/),
        ],
      ],
      SecurityID: [
        this.pinNumber,
        [
          Validators.required,
          Validators.maxLength(4),
          Validators.minLength(4),
          Validators.pattern(/^$|^[A-Za-z0-9]+/),
        ],
      ],
    });
  }

  private activateGiftCard(): void {
    this.cardValidationService.memberId = +this.userService.user.memberId;
    this.spinnerService.showSpinner({
      text: "Card activation being processed…",
    });
    this.cardValidationService.activateCard().subscribe(
      (res) => {
        this.spinnerService.hideSpinner();
        if (res.Result === 0) {
          this.errorMessage = res.ResultMessage;
        } else {
          this.router.navigate(["/thanks"]);
        }
      },
      (error) => {
        this.spinnerService.hideSpinner();
        this.errorMessage = error.Message
          ? error.Message
          : "Something went wrong...";
      }
    );
  }
}
